import { IChildren } from "@components/interfaces/IChildren";
import React from "react";
import "./Motion.scss";

export type DurationVariants = 0 | 1 | 2 | 3 | 4 | 5;
export type SlideDirections = "fromLeft" | "fromRight" | "fromTop" | "fromBottom";

export interface AnimationProps {
  spin?: boolean;
  shake?: boolean;
  appear?: boolean;
  slide?: {
    direction: SlideDirections;
    active: boolean;
  };
  pulse?: boolean;
  duration: DurationVariants;
  style?: Record<any, any>;
  size?: number;
  onAnimationEnd?: () => void;
  onClick?(): void;
  className?: string;
}

const speedTimes = {
  speed0: 200,
  speed1: 300,
  speed2: 600,
  speed3: 1000,
  speed4: 1500,
  speed5: 3000
};

const Motion = ({
  children,
  spin,
  shake,
  appear,
  slide,
  pulse,
  duration,
  style,
  onAnimationEnd = () => {},
  className = ""
}: IChildren & AnimationProps) => {
  const motionRef = React.useRef(null as any);

  const buildAnimation = (): string => {
    let animation = `${className} `;
    if (spin) {
      animation += `spin-${duration}`;
    }
    if (shake) {
      animation += `shake-${duration}`;
    }

    if (appear) {
      animation += `appear-${duration}`;
    }

    if (slide?.active) {
      animation += `slide slide-${slide.direction} slide-${slide.direction}-${duration}`;
    }

    if (pulse) {
      animation += ` pulse pulse-${duration}`;
    }

    return animation;
  };

  React.useEffect(() => {
    setTimeout(async () => {
      onAnimationEnd();
    }, speedTimes[`speed${duration}`]);
  }, [spin, shake, appear, slide, duration, onAnimationEnd]);

  return (
    <div className={`${buildAnimation()} motion`} style={{ ...style }} ref={motionRef}>
      {children}
    </div>
  );
};

export default Motion;
